import { ref } from "vue";

const deferredPrompt = ref<any>(null);
const canInstall = ref(false);
const showBanner = ref(false);

window.addEventListener("beforeinstallprompt", (e: any) => {
    e.preventDefault();
    deferredPrompt.value = e;
    canInstall.value = true;
});

window.addEventListener("appinstalled", () => {
    canInstall.value = false;
    deferredPrompt.value = null;
    showBanner.value = false;
});

export function usePwaInstall() {
    const install = async () => {
        if (!deferredPrompt.value) return;
        deferredPrompt.value.prompt();
        await deferredPrompt.value.userChoice;
        deferredPrompt.value = null;
        canInstall.value = false;
    };

    const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
    const isAndroid = /android/i.test(navigator.userAgent);
    const isStandalone =
        window.matchMedia("(display-mode: standalone)").matches ||
        (window.navigator as any).standalone === true;

    return { canInstall, install, isIOS, isAndroid, isStandalone, showBanner };
}
